var _ellipse, _ellipse2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9526,
    cy: 49.0478,
    rx: 41.9048,
    ry: 41.9048,
    fill: "#E2B946"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.9993,
    cy: 49.9998,
    rx: 37.1429,
    ry: 37.1429,
    fill: "#FFE292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 10C27.9086 10 10 27.9086 10 50C10 72.0914 27.9086 90 50 90C72.0914 90 90 72.0914 90 50C90 27.9086 72.0914 10 50 10ZM0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8259 30C35.2169 30 34.7232 30.4937 34.7232 31.1028V33.3807C33.9348 33.5111 33.1989 33.7123 32.5155 33.9841C31.2014 34.5067 30.0963 35.2011 29.2003 36.0673C28.3043 36.9334 27.6174 37.9265 27.1395 39.0465C26.6766 40.1665 26.4451 41.3163 26.4451 42.4961C26.4451 43.9745 26.6542 45.2214 27.0723 46.2369C27.5054 47.2374 28.0729 48.0737 28.7747 48.7457C29.4766 49.4177 30.2755 49.9627 31.1715 50.3809C32.0675 50.799 32.9785 51.1574 33.9043 51.4561C34.8302 51.7547 35.7411 52.031 36.6371 52.2849C37.5331 52.5387 38.3321 52.8523 39.0339 53.2257C39.7358 53.5841 40.2958 54.0321 40.7139 54.5697C41.147 55.1073 41.3635 55.8017 41.3635 56.6529C41.3635 58.1761 40.8931 59.3483 39.9523 60.1697C39.0115 60.9761 37.6825 61.3793 35.9651 61.3793C34.8451 61.3793 33.8819 61.2299 33.0755 60.9313C32.2841 60.6177 31.5897 60.2742 30.9923 59.9009C30.395 59.5275 29.8798 59.1915 29.4467 58.8929C29.0137 58.5793 28.6105 58.4225 28.2371 58.4225C27.9683 58.4225 27.7145 58.4971 27.4755 58.6465C27.2366 58.7809 27.0425 58.9526 26.8931 59.1617L25.1235 62.0513C25.7507 62.6934 26.4675 63.2758 27.2739 63.7985C28.0803 64.3211 28.939 64.7691 29.8499 65.1425C30.7758 65.5158 31.739 65.7995 32.7395 65.9937C33.3943 66.1305 34.0555 66.2225 34.7232 66.2698V68.8973C34.7232 69.5064 35.2169 70.0001 35.8259 70.0001H38.4204C39.0294 70.0001 39.5231 69.5064 39.5231 68.8973V65.8413C39.8794 65.7433 40.2241 65.6298 40.5571 65.5009C41.9459 64.9483 43.1182 64.2017 44.0739 63.2609C45.0446 62.3051 45.7763 61.1926 46.2691 59.9233C46.7769 58.639 47.0307 57.2651 47.0307 55.8017C47.0307 54.4577 46.8142 53.3153 46.3811 52.3745C45.963 51.4337 45.403 50.6422 44.7011 50.0001C43.9993 49.343 43.2003 48.8054 42.3043 48.3873C41.4083 47.9542 40.4899 47.5809 39.5491 47.2673C38.6083 46.9387 37.6899 46.6326 36.7939 46.3489C35.8979 46.0651 35.099 45.7441 34.3971 45.3857C33.6953 45.0273 33.1278 44.5942 32.6947 44.0865C32.2766 43.5787 32.0675 42.9441 32.0675 42.1825C32.0675 41.5851 32.1721 41.0401 32.3811 40.5473C32.5902 40.0395 32.9038 39.6065 33.3219 39.2481C33.755 38.8897 34.2851 38.6134 34.9123 38.4193C35.5395 38.2102 36.2713 38.1057 37.1075 38.1057C38.0334 38.1057 38.8323 38.2251 39.5043 38.4641C40.1913 38.6881 40.7886 38.9419 41.2963 39.2257C41.8041 39.5094 42.2371 39.7707 42.5955 40.0097C42.9689 40.2337 43.3123 40.3457 43.6259 40.3457C43.9246 40.3457 44.171 40.2785 44.3651 40.1441C44.5742 39.9947 44.7683 39.7633 44.9475 39.4497L46.4483 36.6049C45.3134 35.5297 43.9395 34.6934 42.3267 34.0961C41.4376 33.7668 40.5031 33.5282 39.5231 33.3805V31.1028C39.5231 30.4937 39.0294 30 38.4204 30H35.8259ZM62.0291 61.7825C63.1491 61.7825 64.0899 61.6481 64.8515 61.3793C65.6131 61.1105 66.2179 60.7521 66.6659 60.3041C67.1289 59.8561 67.4574 59.3334 67.6515 58.7361C67.8606 58.1387 67.9651 57.5041 67.9651 56.8321C67.9651 56.1302 67.8531 55.503 67.6291 54.9505C67.4051 54.383 67.0542 53.9051 66.5763 53.5169C66.0985 53.1137 65.4787 52.8075 64.7171 52.5985C63.9705 52.3894 63.067 52.2849 62.0067 52.2849H55.9363V61.7825H62.0291ZM55.9363 38.7553V48.1185H60.7299C62.7907 48.1185 64.3438 47.7451 65.3891 46.9985C66.4494 46.2518 66.9795 45.0646 66.9795 43.4369C66.9795 41.7494 66.5017 40.5473 65.5459 39.8305C64.5902 39.1137 63.0969 38.7553 61.0659 38.7553H55.9363ZM61.0659 34.0961C63.1865 34.0961 65.0009 34.2977 66.5091 34.7009C68.0174 35.1041 69.2494 35.679 70.2051 36.4257C71.1758 37.1723 71.8851 38.0758 72.3331 39.1361C72.7811 40.1963 73.0051 41.391 73.0051 42.7201C73.0051 43.4817 72.8931 44.2134 72.6691 44.9153C72.4451 45.6022 72.0942 46.2518 71.6163 46.8641C71.1534 47.4614 70.5561 48.0065 69.8243 48.4993C69.1075 48.9921 68.2489 49.4102 67.2483 49.7537C71.6984 50.7542 73.9235 53.1585 73.9235 56.9665C73.9235 58.3403 73.6622 59.6097 73.1395 60.7745C72.6168 61.9393 71.8553 62.9473 70.8547 63.7985C69.8542 64.6347 68.6222 65.2918 67.1587 65.7697C65.6953 66.2475 64.0227 66.4865 62.1411 66.4865H49.9107V34.0961H61.0659Z",
    fill: "#F4C130"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 25.1235,
    y: 30,
    width: 48.8,
    height: 41.1029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.10277
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65416
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.9524,
    y1: 44.2857,
    x2: 117.619,
    y2: 86.1905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851334,
    stopColor: "#BC8B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCoins);
export default __webpack_public_path__ + "static/media/live-coins.dfd946e0a25980e4ec7bc5b76a85dd83.svg";
export { ForwardRef as ReactComponent };